import {useGrpcRequestMutation} from '@aboutyou/data-fetcher';
import {FormService_DeclarationOfLossFormLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/form/v1/service.grpc.lazy';

export const useSubmitDeclarationOfLossForm = () => {
  const requestCallback = useGrpcRequestMutation(
    FormService_DeclarationOfLossFormLazy,
  );

  return requestCallback;
};
